import React from 'react';
import {LoadingListItemContainer, LoadingListItemHero, LoadingListItemText, LoadingNewsListStyledIntro} from "../../../utils/loading-styles";

export const LoadingNewsListItem = () => {

    return (
        <LoadingListItemContainer>
            <LoadingListItemHero>
                &nbsp;
            </LoadingListItemHero>
            <LoadingListItemText>
                <h2>&nbsp;</h2>
                <LoadingNewsListStyledIntro>&nbsp;</LoadingNewsListStyledIntro>
            </LoadingListItemText>
        </LoadingListItemContainer>
    )
}